import { getABExperimentVariant } from '@nykaa/experiment-sdk/store/selectors';

const MULTICOUPON_EXPERIMENT_ID = 'coupon-widget-multicoupon-ab';
const COUPON_TYPE_BY_VARIANT: Record<string, string> = {
  multicoupon: '0',
  'multicoupon-prepaid': '1',
  'multicoupon-noreturn': '2',
  'multicoupon-prepaid-noreturn': '3',
};

const MULTICOUPON_ENDPOINT_PATHS = [
  '/cartapi/v1/reward/apply',
  '/cartapi/v1/reward/remove',
  '/cartapi/v1/cart/refresh',
  '/cartapi/v3/coupon/list',
  '/cartapi/v1/sample/list',
  '/cartapi/v1/sample/add',
  '/cartapi/v1/sample/remove',
  '/cartapi/v1/item/add',
  '/cartapi/v1/item/add/refresh',
  '/cartapi/v1/item/update',
  '/cartapi/v1/item/remove',
  '/cartapi/v1/item/replace',
  '/cartapi/v1/coupon/apply',
  '/cartapi/v1/coupon/remove',
  '/cartapi/v1/address/add',
  '/cartapi/v1/historyItem/remove',
  '/cartapi/v2/address/add',
  '/offer/api/v1/product/customer/best/offers',
  '/offer/api/v1/product/customer/offer',
];


interface ExperimentState {
  abExperiments?: Record<string, string>;
  remoteConfigs?: { isExperimentV2Enabled?: boolean; };
}

export const getMulticouponHeaderForUrl = (
  url: string,
  state?: ExperimentState
): Record<string, string> => {
  const isMulticouponEndpoint = MULTICOUPON_ENDPOINT_PATHS.some((path) => url.includes(path));
  if (!isMulticouponEndpoint) return {};

  const { isEligible = false, variant = '' } = getABExperimentVariant(
    { abExperiments: state?.abExperiments || {} },
    MULTICOUPON_EXPERIMENT_ID
  );
  const couponType = COUPON_TYPE_BY_VARIANT[variant];
  if (!state?.remoteConfigs?.isExperimentV2Enabled || !isEligible || !couponType) return {};

  return {
    experiment: 'multicoupon:true',
    'X-MULTI-COUPON-TYPE': couponType,
  };
};
